/* eslint-disable max-classes-per-file */
export interface GreenCertificationInterface {
  id: number;
  nameEn: string;
  nameTh: string;
}
export class GreenCertificationClass {
  id: number;

  nameEn: string;

  nameTh: string;

  constructor(res: any) {
    this.id = res?.id || 0;
    this.nameEn = res?.nameEn || "";
    this.nameTh = res?.nameTh || "";
  }
}
export interface RankingDataInterface {
  rankingString: string;
  rankingOutOf: string;
  geoLocationId: string;
  ranking: string;
  geoLocationName: string;
  rankingStringDetail: string;
}
export class RankingDataClass {
  rankingString: string;

  rankingOutOf: string;

  geoLocationId: string;

  ranking: string;

  geoLocationName: string;

  rankingStringDetail: string;

  constructor(res: any) {
    this.rankingString = res?.ranking_string ?? "";
    this.rankingOutOf = res?.ranking_out_of ?? "";
    this.geoLocationId = res?.geo_location_id ?? "";
    this.ranking = res?.ranking ?? "";
    this.geoLocationName = res?.geo_location_name ?? "";
    this.rankingStringDetail = res?.ranking_string_detail ?? "";
  }
}
export interface SubRatingsInterface {
  ratingImageUrl: string;
  name: string;
  value: string;
  localizedName: string;
}
export class SubRatingsClass {
  ratingImageUrl: string;

  name: string;

  value: string;

  localizedName: string;

  constructor(res: any) {
    this.ratingImageUrl = res?.rating_image_url || "";
    this.name = res?.name || "";
    this.value = res?.value || "";
    this.localizedName = res?.localized_name || "";
  }
}
export interface HotelBookingInterface {
  bookable: boolean;
  bookingUrl: string;
}
export class HotelBookingClass {
  bookable: boolean;

  bookingUrl: string;

  constructor(res: any) {
    this.bookable = res?.bookable || false;
    this.bookingUrl = res?.booking_url || "";
  }
}
export interface ReviewRatingCountInterface {
  [key: number]: string;
}
export class ReviewRatingCountClass {
  [key: number]: string;

  constructor(res: any) {
    this["1"] = res?.["1"] || "0";
    this["2"] = res?.["2"] || "0";
    this["3"] = res?.["3"] || "0";
    this["4"] = res?.["4"] || "0";
    this["5"] = res?.["5"] || "0";
  }
}
export interface SubReviewInterface {
  id: string;
  lang: string;
  locationId: string;
  publishedDate: string;
  rating: number;
  helpfulVotes: string;
  ratingImageUrl: string;
  url: string;
  tripType: string | null;
  travelDate: string;
  text: string;
  user: {
    username: string;
    userLocation: {
      name: string;
      id: number | null;
    };
  };
  title: string;
  isMachineTranslated: boolean;
}
export interface UserLocationInterface {
  name: string;
  id: number | null;
}
export class UserLocationClass {
  name: string;

  id: number | null;

  constructor(res: any) {
    this.name = res?.name || "";
    this.id = res?.id || null;
  }
}
export class SubReviewClass {
  id: string;

  lang: string;

  locationId: string;

  publishedDate: string;

  rating: number;

  helpfulVotes: string;

  ratingImageUrl: string;

  url: string;

  tripType: string | null;

  travelDate: string;

  text: string;

  user: {
    username: string;
    userLocation: UserLocationInterface;
  };

  title: string;

  isMachineTranslated: boolean;

  constructor(res: any) {
    this.id = res?.id || "";
    this.lang = res?.lang || "";
    this.locationId = res?.location_id || "";
    this.publishedDate = res?.published_date || "";
    this.rating = res?.rating || 0;
    this.helpfulVotes = res?.helpful_votes || "";
    this.ratingImageUrl = res?.rating_image_url || "";
    this.url = res?.url || "";
    this.tripType = res?.trip_type || "";
    this.travelDate = res?.travel_date || "";
    this.text = res?.text || "";
    this.user = {
      username: res?.user?.username || "",
      userLocation:
        new UserLocationClass(res?.user?.user_location) ||
        new UserLocationClass({}),
    };
    this.title = res?.title || "";
    this.isMachineTranslated = res?.is_machine_translated || false;
  }
}
export class AddressObjClass {
  street1: string;

  street2: string;

  city: string;

  state: string;

  country: string;

  postalcode: string;

  addressString: string;

  constructor(res: any) {
    this.street1 = res?.street1 || "";
    this.street2 = res?.street2 || "";
    this.city = res?.city || "";
    this.state = res?.state || "";
    this.country = res?.country || "";
    this.postalcode = res?.postalcode || "";
    this.addressString = res?.address_string || "";
  }
}
export class TripTypesClass {
  name: string;

  value: string;

  localizedName: string;

  constructor(res: any) {
    this.name = res?.name || "";
    this.value = res?.value || "";
    this.localizedName = res?.localized_name || "";
  }
}
export class AncestorsClass {
  abbrv: string;

  level: string;

  name: string;

  locationId: string;

  constructor(res: any) {
    this.abbrv = res?.abbrv || "";
    this.level = res?.level || "";
    this.name = res?.name || "";
    this.locationId = res?.location_id || "";
  }
}
export class ReviewClass {
  addressObj: AddressObjInterface;

  reviewCount: number;

  timezone: string;

  latitude: number;

  rating: number;

  locationId: string;

  tripTypes: TripTypesInterface[];

  reviews: SubReviewInterface[];

  writeReview: string;

  ancestors: AncestorsInterface[];

  brand: string;

  longitude: number;

  hours: number;

  percentRecommended: number;

  hotelBooking: HotelBookingInterface;

  parentBrand: string;

  reviewRatingCount: ReviewRatingCountInterface;

  subratings: SubRatingsInterface[];

  rankingData: RankingDataInterface;

  constructor(data: any) {
    this.addressObj =
      new AddressObjClass(data?.addressObj) || new AddressObjClass({});
    this.timezone = data?.timezone || "";
    this.latitude = data?.latitude || 0;
    this.rating = data?.rating || 0;
    this.locationId = data?.location_id || 0;
    this.tripTypes =
      (data?.trip_types || []).map(
        (val: TripTypesInterface) => new TripTypesClass(val),
      ) || [];
    this.reviews =
      (data?.reviews || []).map(
        (val: SubReviewInterface) => new SubReviewClass(val),
      ) || [];
    this.writeReview = data?.write_review || "";
    this.ancestors =
      (data?.ancestors || []).map(
        (val: AncestorsInterface) => new AncestorsClass(val),
      ) || [];

    this.reviewCount = data?.review_count || 0;
    this.brand = data?.brand || "";
    this.longitude = data?.longitude || 0;
    this.hours = data?.hours || 0;
    this.percentRecommended = data?.percent_recommended || 0;
    this.hotelBooking = new HotelBookingClass(data?.hotel_booking);
    this.parentBrand = data?.parent_brand || "";
    this.reviewRatingCount =
      new ReviewRatingCountClass(data?.review_rating_count) ||
      new ReviewRatingCountClass({});

    this.subratings =
      (data?.subratings || []).map(
        (val: SubRatingsInterface) => new SubRatingsClass(val),
      ) || [];

    this.rankingData =
      new RankingDataClass(data?.ranking_data) || new RankingDataClass({});
  }
}
export interface TripTypesInterface {
  name: string;
  value: string;
  localizedName: string;
}

export interface AddressObjInterface {
  street1: string;
  street2: string;
  city: string;
  state: string;
  country: string;
  postalcode: string;
  addressString: string;
}
export interface AncestorsInterface {
  abbrv: string;
  level: string;
  name: string;
  locationId: string;
}

export interface ReviewInterface {
  addressObj: AddressObjInterface;
  timezone: string;
  latitude: number;
  rating: number;
  reviewCount: number;
  locationId: string;
  tripTypes: TripTypesInterface[];
  reviews: SubReviewInterface[];
  writeReview: string;
  ancestors: AncestorsInterface[];
  brand: string;
  longitude: number;
  hours: number;
  percentRecommended: number;
  hotelBooking: HotelBookingInterface;
  parentBrand: string;
  reviewRatingCount: ReviewRatingCountInterface;
  subratings: SubRatingsInterface[];
  rankingData: RankingDataInterface;
}
export interface FacilitiesInterface {
  id: number;
  image: string;
  name: string;
}
export class FacilitiesClass {
  id: number;

  image: string;

  name: string;

  constructor(res: any) {
    this.id = res?.id || 0;
    this.image = res?.image || "";
    this.name = res?.name || "";
  }
}
export interface UsefulDetailInterface {
  groupId: number;
  groupName: string;
  details: string[];
}
export class UsefulDetailClass {
  groupId: number;

  groupName: string;

  details: string[];

  constructor(res: any) {
    this.groupId = res?.groupId || 0;
    this.groupName = res?.groupName || "";
    this.details = res?.details || "";
  }
}
export interface FacilitiesDetailInterface {
  groupId: number;
  groupName: string;
  details: FacilitiesInterface[];
}
export class FacilitiesDetailClass {
  groupId: number;

  groupName: string;

  details: FacilitiesInterface[];

  constructor(res: any) {
    this.groupId = res?.groupId || 0;
    this.groupName = res?.groupName || "";
    this.details =
      (res.details || []).map(
        (val: FacilitiesInterface) => new FacilitiesClass(val),
      ) || [];
  }
}
export class ResponseGetHotelDetailBySlugClass {
  id: number;

  status?: boolean;

  name: string;

  slug: string;

  description: string;

  starRating: number;

  latitude: number;

  longitude: number;

  phoneNumber: string;

  faxNumber: string;

  address: string;

  countryName: string;

  countrySlug: string;

  cityId: number;

  cityName: string;

  citySlug: string;

  areaName: string;

  areaSlug: string;

  destinationId: number;

  photoGallery: string[];

  useful: {
    group: string;
    detail: string[];
  };

  facilities: FacilitiesInterface[];

  amenities: string[];

  usefulDetail: UsefulDetailInterface;

  facilitiesDetail: FacilitiesDetailInterface[];

  amenitiesDetail: FacilitiesInterface[];

  important_note: string;

  observation: string;

  isRegister: boolean;

  isThaiHotelMember: boolean;

  shaPlus: boolean;

  shaExtraPlus: boolean;

  isFavourite: boolean;

  isGreenCertificate: boolean;

  greenCertifications: GreenCertificationInterface[];

  review: ReviewInterface;

  hotelSlugPath: string;

  constructor(data: any) {
    this.id = data?.id || 0;
    this.name = data?.name || "";
    this.description = data?.description || "";
    this.starRating = data?.starRating || 0;
    this.latitude = data?.latitude || 0;
    this.longitude = data?.longitude || 0;
    this.phoneNumber = data?.phoneNumber || "";
    this.faxNumber = data?.faxNumber || "";
    this.address = data?.address || "";
    this.countryName = data?.countryName || "";
    this.cityName = data?.cityName || "";
    this.cityId = data?.cityId || 0;

    this.areaName = data?.areaName || "";
    this.destinationId = data?.destinationId || 0;
    this.photoGallery = data?.photoGallery || "";
    this.isFavourite = data?.isFavourite || false;
    this.useful = {
      group: data?.useful?.group || null,
      detail: data?.useful?.detail || null,
    };

    this.facilities =
      (data?.facilities || []).map(
        (val: FacilitiesInterface) => new FacilitiesClass(val),
      ) || [];
    this.amenities =
      (data?.amenities || []).map(
        (val: FacilitiesInterface) => new FacilitiesClass(val),
      ) || [];

    this.usefulDetail = new UsefulDetailClass(data?.usefulDetail);
    this.facilitiesDetail =
      (data?.facilitiesDetail || []).map(
        (val: FacilitiesDetailInterface) => new FacilitiesDetailClass(val),
      ) || [];
    this.amenitiesDetail =
      (data?.amenitiesDetail || []).map(
        (val: FacilitiesInterface) => new FacilitiesClass(val),
      ) || [];
    this.important_note = data?.important_note || "";
    this.observation = data?.observation || "";
    this.isRegister = data?.isRegister || false;
    this.isThaiHotelMember = data?.isThaiHotelMember || false;
    this.shaPlus = data?.shaPlus || false;
    this.shaExtraPlus = data?.shaExtraPlus || false;

    this.review = new ReviewClass(data?.review) || new ReviewClass({});

    this.greenCertifications =
      (data?.greenCertifications || []).map(
        (val: GreenCertificationInterface) => new GreenCertificationClass(val),
      ) || [];

    this.countrySlug = data?.countrySlug;
    this.citySlug = data?.citySlug;
    this.areaSlug = data?.areaSlug;
    this.slug = data?.slug;
    this.hotelSlugPath = `/${this.countrySlug}/${this.citySlug}/${this.areaSlug}/${this.slug}`;
    this.isGreenCertificate = data?.isGreenCertificate || false;
  }
}
export interface ResponseGetHotelDetailBySlugInterface {
  id: number;

  name: string;

  slug: string;

  description: string;

  starRating: number;

  latitude: number;

  longitude: number;

  phoneNumber: string;

  faxNumber: string;

  address: string;

  countryName: string;

  countrySlug: string;

  cityId: number;

  cityName: string;

  citySlug: string;

  areaName: string;

  areaSlug: string;

  destinationId: number;

  photoGallery: string[];

  useful: {
    group: string;
    detail: string[];
  };

  facilities: FacilitiesInterface[];

  amenities: string[];

  usefulDetail: UsefulDetailInterface;

  facilitiesDetail: FacilitiesDetailInterface[];

  amenitiesDetail: FacilitiesInterface[];

  important_note: string;

  observation: string;

  isRegister: boolean;

  isThaiHotelMember: boolean;

  shaPlus: boolean;

  shaExtraPlus: boolean;

  isFavourite: boolean;

  isGreenCertificate: boolean;

  greenCertifications: GreenCertificationInterface[];

  review: ReviewInterface;

  hotelSlugPath: string;
}
export interface ContentNearByInterface {
  distance: number;
  label: string;
}
export interface DataHotelsNearByInterface {
  hotelId: number;
  landmarks: string[];
}
export class ContentNearByClass {
  distance: number;

  label: string;

  constructor(res: any) {
    this.distance = res?.distance || 0;
    this.label = res?.label || "";
  }
}
export interface ResponseHotelNearByInterface {
  contents: ContentNearByInterface[];

  header: string;

  icon: string;
}

export class ResponseHotelNearByClass {
  contents: ContentNearByInterface[];

  header: string;

  icon: string;

  constructor(data: any) {
    this.contents =
      (data.contents || []).map(
        (val: ContentNearByInterface) => new ContentNearByClass(val),
      ) || [];
    this.header = data.header || "";
    this.icon = data.icon || "";
  }
}

export class ResponseHotelsNearByClass {
  status: boolean;

  message: string;

  data: DataHotelsNearByInterface[];

  constructor(res: any) {
    this.status = res?.status || false;
    this.message = res?.message || "";
    this.data = res?.data;
  }
}

export interface RequestHotelNearByInterface {
  hotel_id: number;
}

export interface RequestHotelsNearByInterface {
  hotelId: string[];
}

export interface RequestListHotelMapInterface {
  hotel_id: number;
  country_slug: string;
  latitude: number;
  longitude: number;
}
export interface ListMapReviewInterface {
  numReviews: number;
  rating: number;
  textRatingDetail: string;
}
export class ListMapReviewClass {
  numReviews: number;

  rating: number;

  textRatingDetail: string;

  constructor(res: any) {
    this.numReviews = res?.numReviews || 0;
    this.rating = res?.rating || 0;
    this.textRatingDetail = res?.textRatingDetail || "";
  }
}
export interface ResponseListHotelMapInterface {
  id: number;

  review: ListMapReviewInterface;

  name: string;

  hotelStar: number;

  latitude: number;

  longitude: number;

  hotelSlugPath: string;

  isGreenCertificate: boolean;

  isFavourite: boolean;
}
export class ResponseListHotelMap {
  id: number;

  review: ListMapReviewInterface;

  name: string;

  hotelStar: number;

  latitude: number;

  longitude: number;

  hotelSlugPath: string;

  isGreenCertificate: boolean;

  isFavourite: boolean;

  images: string[];

  areaSlug: string;

  citySlug: string;

  constructor(res: any) {
    this.id = res?.id || 0;
    this.review =
      new ListMapReviewClass(res?.review) || new ListMapReviewClass({});
    this.name = res?.name || "";
    this.hotelStar = res?.hotelStar || 0;
    this.latitude = res?.latitude || 0;
    this.longitude = res?.longitude || 0;
    this.hotelSlugPath = res?.hotelSlugPath || "";
    this.isGreenCertificate = res?.isGreenCertificate || false;
    this.isFavourite = res?.isFavourite || false;
    this.images = res?.images || [];
    this.areaSlug = res?.areaSlug || "";
    this.citySlug = res?.citySlug || "";
  }
}
